<template>
  <div class="recharge_page">
    <h1>Welcome to chenxi's App</h1>
    <p>This is the Recharge Page of llmbot.</p>
  </div>
</template>

<script>
export default {
  name: 'RechargePage',
  data() {
    return {
      // 可以在这里添加数据
    }
  }
}
</script>

<style scoped>
.recharge_page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
h1 {
  color: #42b983;
}
</style>